<div *ngIf="authService.user | async" class="shadow-sm d-flex flex-row justify-content-between justify-content-sm-end p-2 bg-light backClass">
    <button class="d-flex btn btn-white d-sm-none" type="button" data-toggle="collapse" data-target="#sidebar" aria-controls="sidebar" aria-expanded="true" aria-label="Toggle Sidebar"><i class="material-icons">dehaze</i></button>

    <div class="dropdown">
        <button *ngIf="authService.user | async" class="btn btn-secondary dropdown-toggle backbtnClass" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      {{ displayName }}
    </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" (click)="logout()">Sortir</a>
        </div>
    </div>
</div>